import { DocumentType } from "components/AdminDocuments"
import { OptionsFormik } from "components/inputs/Options"
import { PageType } from "api/types"
import { TextInputFormik } from "components/inputs/TextInput"
import { css } from "@emotion/css"
import { fetchMediaTypes } from "api/media-types"
import { useI18n } from "providers/I18n"
import { useQuery } from "react-query"

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  `,
  selectWrapper: css`
    max-width: 20rem;
  `,
  placeholder: css`
    color: var(--dark-grey);
  `,
}

export type NewDocumentFieldGroupProps = {
  type: PageType | "invoice"
  disabled: boolean
  margin?: "none" | "dense" | "normal"
  documentTypes?: DocumentType[]
}

export function NewDocumentFieldGroup(props: NewDocumentFieldGroupProps) {
  const { type, disabled, margin, documentTypes } = props
  const { t } = useI18n()

  const { data: q } = useQuery(["media-types"], fetchMediaTypes, {
    enabled: type === "plan",
  })

  const mediaTypes = q?.data

  return (
    <div className={styles.container}>
      {type === "plan" ? (
        <div className={styles.selectWrapper}>
          <OptionsFormik
            disabled={disabled}
            name="mediaType"
            label="Media Type"
            size="medium"
            margin={margin}
            InputLabelProps={{
              classes: {
                root: styles.placeholder,
              },
            }}
            options={
              mediaTypes?.map((mt) => ({
                label: mt?.name,
                value: mt?.name,
              })) || []
            }
          />
        </div>
      ) : (
        <div className={styles.selectWrapper}>
          <OptionsFormik
            disabled={disabled}
            name="documentType"
            label={t("campaign.documents.type")}
            size="medium"
            margin={margin}
            InputLabelProps={{
              classes: {
                root: styles.placeholder,
              },
            }}
            options={
              documentTypes || [
                {
                  label: t("campaign.documents.brief"),
                  value: t("campaign.documents.brief"),
                },
                {
                  label: t("campaign.documents.presentation"),
                  value: t("campaign.documents.presentation"),
                },
                {
                  label: t("campaign.documents.report"),
                  value: t("campaign.documents.report"),
                },
                {
                  label: t("campaign.documents.atb"),
                  value: t("campaign.documents.atb"),
                },
                {
                  label: t("campaign.documents.other"),
                  value: t("campaign.documents.other"),
                },
              ]
            }
          />
        </div>
      )}
      <TextInputFormik
        fullWidth
        rows={2}
        multiline={true}
        name="description"
        disabled={disabled}
        placeholder={t("campaign.documents.description.placeholder")}
      />
    </div>
  )
}
